import request from '@/utils/request'


//通过字典id查询数据
export function getPmiDic(params) {
    return request({
        url: '/api/PmiDictionary/GetByTypeId',
        method: 'get',
        params
    })
}



export function getById(params) {
    return request({
        url: '/api/Document/Get',
        method: 'get',
        params
    })
}


export function DocumentGetDetail(params) {
    return request({
        url: '/api/Document/GetDetail',
        method: 'get',
        params
    })
}

//获取动态ip
export function getDocumentIp(params){
    return request({
        url: '/uploadfile/Home/GetIp',
        method: 'get',
        params
    })
}

//添加评论
export function addDocreview(data) {
    return request({
        url: '/api/DocumentTalk/Add',
        method: 'post',
        data
    })
}

//评论列表
export function getByDocumentTalk(params) {
    return request({
        url: '/api/DocumentTalk/Load',
        method: 'get',
        params
    })
}
//热门资源排行
export function DocumentHotTongJi(params) {
    return request({
        url: '/api/Document/HotTongJi',
        method: 'get',
        params
    })
}


export function GetCourseAll(params) {
    return request({
        url: '/api/TrainJoin/GetCourseAll',
        method: 'get',
        params
    })
}

//首页警种统计
export function DocumentJzTongJi(params) {
    return request({
        url: '/api/Document/JzTongJi',
        method: 'get',
        params
    })
}
// 点击后阅读数加一
export function DocumentRead(id, params) {
    return request({
        url: '/api/Document/Read?id=' + id,
        method: 'GET',
        params
    })
}

// 删除
export function Deleteload(data) {
    return request({
        url: '/api/Document/Delete',
        method: 'post',
        data
    })
}

export function DocumentHotDocmentList(params) {
    return request({
        url: '/api/Document/HotDocmentList',
        method: 'get',
        params
    })
}
//添加多个资源
export function docmAddMore(data) {
    return request({
        url: '/resource/Document/AddMore',
        method: 'post',
        data
    })
}
//  加载  
export function getDocumentLoad(params) {
    return request({
        url: '/api/Document/LoadQT',
        method: 'get',
        params
    })
}

//上传文件列表
export function getuploadFileListApi(params) {
    return request({
        url: '/api/Document/Load',
        method: 'get',
        params
    })
}

export function getDocumentByClass(params) {
    return request({
        url: '/api/Document/GetListByClass',
        method: 'get',
        params
    })
}
export function GetDocSecondList() {
    return request({
        url: '/api/DocumentType/GetSecondList',
        method: 'get',
    })
}

// 转码m3u8
export function ProgressConvertM3U8(params) {
    return request({
        url: '/resource/Progress/ConvertM3U8',
        method: 'get',
        params
    })
}

// 资源学习记录 
export function DocumentRecordst(data) {
    return request({
        url: '/api/DocumentRecord/Add',
        method: 'post',
        data
    })
}

// 查询播放记录
export function DocumentRecordGet(params) {
    return request({
        url: '/api/DocumentRecord/Get',
        method: 'get',
        params
    })
}

// 提交记录 
export function AddNoteRecord(params) {
    return request({
        url: '/api/Center/AddNoteRecord',
        method: 'get',
        params
    })
}

// 下载
export function Download(params) {
    return request({
        url: '/api/Document/Download',
        method: 'GET',
        params
    })
}
// 资源类型
export function DocumentTypeGetTree(params) {
    return request({
        url: '/api/DocumentType/GetTreeCount',
        method: 'GET',
        params
    })
}
